jQuery('.navbar-toggler').click(function() {
  jQuery('.burger.burger-slide').toggleClass('open');
});

jQuery(document).ready(function() {

  // var current = window.location.href.replace(/^http(s?):/i, "");
  var current = window.location.href
  document.querySelectorAll('.sidebar-navigation-menu-blog .nav-link').forEach(e => {
    if(e.href == current) {
      e.classList.add('active');
    }
  });

  var trending = document.getElementById('menu-trending-navigation');

  trending.querySelectorAll('li a').forEach(function(el) {
    el.classList.add('disabled');
  });

});

sidebarCollpaseVisibilityCheck();

//checks for browser window resizing up to desktop to show hidden collapsed items
jQuery(window).on("resize", function(e){
  e.stopPropagation();
  e.preventDefault();
  sidebarCollpaseVisibilityCheck();
})

function sidebarCollpaseVisibilityCheck(){
  var sidebarCollapse = document.querySelectorAll('[data-bs-target="#sidebarNavigation"]');
  if(sidebarCollapse.length === 1 ){
    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    if(viewportWidth >= 786){
      sidebarCollapse[0].click();
    }
  }
}
